import React from 'react';

import Button from '../common/Button';
import Dropdown from '../common/Dropdown';

import {ABOUT_URL} from '../../config/urls';
import {BLOG_URL} from '../../config/urls';
import {CONSULTING_FORM_URL} from '../../config/urls';
import {useMovePage} from '../../hooks/useMovePage';
import openNewWindow from '../../utils/openNewWindow';
import styles from './styles/header.module.css';

import {ReactComponent as DarvisLogoImg} from '../../assets/logo/darvis-logo.svg';

export default function Header() {
  const movePage = useMovePage();

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div
          className={styles.logo}
          onClick={() => movePage('/')}
        >
          <DarvisLogoImg />
        </div>
        <div className={styles.boxMenu}>
          <div className={styles.menu}>
            <Dropdown />
            <Button text='회사 소개'
                    width='60px'
                    height='19px'
                    padding='0'
                    backgroundColor='#FFF'
                    border='none'
                    borderRadius='none'
                    fontSize='16px'
                    fontWeight='500'
                    textColor='#000'
                    onClick={() => movePage('about')}
            />
            <Button text='도입 사례'
                    width='60px'
                    height='19px'
                    padding='0'
                    backgroundColor='#FFF'
                    border='none'
                    borderRadius='none'
                    fontSize='16px'
                    fontWeight='500'
                    textColor='#000'
                    onClick={() => openNewWindow(BLOG_URL)}
            />
          </div>
          <div className={styles.boxBtn}>
            <Button text='소개서 보기'
                    width='113px'
                    height='38px'
                    padding='8px 20px'
                    backgroundColor='#B7B6C0'
                    border='none'
                    borderRadius='7px'
                    fontSize='16px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow(ABOUT_URL)}
            />
            <Button text='컨설팅 신청'
                    width='113px'
                    height='38px'
                    padding='8px 20px'
                    backgroundColor='#825DFC'
                    border='none'
                    borderRadius='7px'
                    fontSize='16px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow(CONSULTING_FORM_URL)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
